import { useQuery } from '@tanstack/react-query';
import { DataService } from '@/services/dataService';
import { queryKeys } from './queryKeys';

export function useDashboardStatsQuery(enabled: boolean) {
    return useQuery({
        queryKey: queryKeys.dashboardStats,
        queryFn: () => DataService.getDashboardStats(),
        enabled,
        staleTime: 60 * 1000, // 1 min - stats cached in DataService too
    });
}
